export default {
  generic: 'Algo deu errado. Tente novamente.',
  network: 'Falha de rede. Verifique sua conexão.',
  not_found: 'Página não encontrada.',
  not_found_body: 'O endereço que você tentou abrir não existe ou foi movido.',
  forbidden: 'Você não tem permissão para acessar este recurso.',
  session_expired: 'Sessão expirada. Entre novamente.',
  server: 'Erro interno. Tente novamente em instantes.',

  // Mapeamento de códigos estáveis da API (ApiProblem) → mensagem amigável.
  code: {
    ATTEMPT_INVALID: 'Tentativa de pareamento inválida.',
    CODE_EXPIRED: 'Código expirado ou já utilizado.',
    CODE_INVALID: 'Código inválido ou já utilizado.',
    CONFIG_MISSING: 'Configuração ausente.',
    CONSENT_VERSION_MISMATCH: 'Versão de consentimento desconhecida.',
    DEVICE_REVOKED: 'Este dispositivo foi revogado.',
    INSUFFICIENT_SCOPE: 'Permissão insuficiente para esta operação.',
    LICENSE_EXHAUSTED: 'Licenças do produto esgotadas.',
    LICENSE_UNAVAILABLE: 'A conta não possui licença do produto.',
    PAIRING_CANCELLED: 'Pareamento cancelado.',
    PAIRING_LOCKED: 'Número máximo de tentativas excedido. Gere um novo código.',
    PAIRING_STATE: 'O pareamento está em outro estado.',
    PAIRING_UNAVAILABLE: 'Não foi possível gerar um código agora.',
    REFRESH_EXPIRED: 'Sessão do dispositivo expirada por inatividade.',
    REFRESH_INVALID: 'Credencial de dispositivo inválida.',
    SHARING_INACTIVE: 'Compartilhamento não está ativo neste aparelho.',
    SUBJECT_EXISTS: 'Já existe uma pessoa com esse nome.',
    TOKEN_EXPIRED: 'Sessão expirada — entre novamente.',
    TOKEN_INVALID: 'Credencial inválida.',
    TOKEN_MISSING: 'Credencial ausente.',
  },
}
